/* DeleteAction.js */

"use strict";

class DeleteAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, OsUpgradePlan) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._osPlan = OsUpgradePlan;
        this._selectedPlanId = [];
        this._selectedPlanName = [];

        this._selectedPlanId = this._gameEditor.getPlan().getId();
        this._selectedPlanName = this._gameEditor.getPlan().getName();
        this.doTheThang = this.doTheThang.bind(this);
        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedPlanId) {
            return this._gameEditor.runQuickConfirmationActionWorkflow(
                {
                    message: 'Are you sure you want to permanently delete "' + this._selectedPlanName + " ?",
                    title: "Delete",
                    confirmDetails: {
                        text: "Confirm",
                        type: "destructive"
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text"
                    }
                },
                this.doTheThang
            );
        } else {
            return Promise.resolve();
        }
    }

    doTheThang() {
        let workTarget = {
            category: "entity",
            entityType: "OsUpgradePlan",
            method: "single",
            id: this._selectedPlanId
        };
        const showProgFunc = () => {
            this._modalUserFeedback.showLoadingProgress(`Deleting ${this._selectedPlanName}`);
        };
        return this._osPlan.runDeletePlanWork(this._activeOrgId, workTarget, undefined, showProgFunc).then((workResults) => {
            this._osPlan.throwWorkErrors(workResults);
            this._activeView._gameEditor._planDeleted = true;
            return Promise.resolve();
        });
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.OsUpgradePlan"
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    shown: true,
    title: "Delete OS Plan",
    order: 8
};
